<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span v-if="id > 0" class="pr-2 mr-2 font-bold text-2xl"
        >Pengeluaran - Edit</span
      >
      <span v-else class="pr-2 mr-2 font-bold text-2xl"
        >Pengeluaran - Tambah</span
      >
      <div>
        <i class="pi pi-home mr-2"></i>
        <span v-if="id > 0" class="font-small"
          >/ Keuangan / Transaksi / Pengeluaran / Edit</span
        >
        <span v-else class="font-small"
          >/ Keuangan / Transaksi / Pengeluaran / Tambah</span
        >
      </div>
    </div>
    <form-pengeluaran :id="id" />
  </div>
</template>

<script>
import FormPengeluaran from '@/components/keuangan/FormPengeluaran'

export default {
  components: {
    FormPengeluaran,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
    }
  },
}
</script>
